// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

// Version token that will be replaced by the prepack command
/** The version of the SignalR Message Pack protocol library. */
export { VERSION } from "./pkg-version";

export { MessagePackHubProtocol } from "./MessagePackHubProtocol";

export { MessagePackOptions } from "./MessagePackOptions";
